































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { SheetListCondition, Sheet } from "../../modules/teacher/SheetList"


export interface Data {
  condition: SheetListCondition
  sheets: Sheet[]
  totalCount: number
  school_id: number
  errors: string[]
  isShow: boolean
  WebupTypeEnum: Readonly<{QR_READ: number; FILE_NAME_READ: number;}>
  progress: string
  isDispProgress: boolean
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){
    
    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: context.root.$store.state.sheetListCondition,
      sheets: new Array<Sheet>(),
      totalCount: 0,
      school_id: context.root.$store.state.currentUser.school_id,
      errors: [],
      isShow: false,
      WebupTypeEnum: Common.WebupTypeEnum,
      progress: "0.0",
      isDispProgress: false,
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      state.errors = [];
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/sheet_list?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.sheets = response.data.sheets.map((x: any) => new Sheet(x));
        state.totalCount = state.sheets.length > 0 ? state.sheets[0].full_count : 0;
        context.root.$store.commit("setSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * admin権限で表示される学校プルダウン変更
     ******************************/

    const schoolChanged = async () => {

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/sheet_list/update_admin_school/${state.school_id}`).then(response => {
        context.root.$store.commit("setCurrentUserSchoolId", state.school_id);
        context.root.$store.commit("setCurrentUserSchoolOptions", response.data.school_options);
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 取込日を画面表示文言にコンバート
     ******************************/

    const convertCaptureDate = (date: string) => {
      return date ? moment(date).format('Y年M月D日') : "-";
    };

    /******************************
     * 取込日を画面表示文言にコンバート
     ******************************/

    const convertAggregatedAt = (date: string) => {
      return date ? moment(date).format('Y年M月D日 HH時mm分') : "-";
    };

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new SheetListCondition();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 採点設定アイコン押下
     ******************************/

    const toSaitenList = (sheet: any, isPendingOnly: boolean) => {
      context.root.$store.commit("setIsPendingOnly", isPendingOnly);
      context.root.$router.push(`/teacher_site/saiten_list/${sheet.id}`).catch(err => {});
    };

    /******************************
     * 画面リロード
     ******************************/

    const reload = () => {
      location.reload();
    };

    /******************************
     * Webup画面へ遷移
     ******************************/

    const goWebupList = (webup_type: number) => {
      context.root.$store.commit("setWebupType", webup_type);
      context.root.$router.push(`/teacher_site/webup_list`);
    }

    /******************************
     * 一括クラス集計
     ******************************/

    const sumupClassifcation = async () => {
      const targetSheetIds = state.sheets.filter(sheet => sheet.progress_rate == 100 && !sheet.aggregated_at).map(sheet => sheet.id);
      if(targetSheetIds.length == 0){
        alert("クラス集計対象がありません。");
        return;
      }

      if(!window.confirm("一括クラス集計を開始します。\nよろしいですか？")){
        return;
      }

      state.isDispProgress = true;
      state.progress = "0.00";

      let completedCount = 0;

      context.root.$store.dispatch("showOverlay", "クラス集計中。画面を閉じずにそのままお待ちください。途中で画面を閉じると処理が中断されます。");

      for(let i = 0; i < targetSheetIds.length; i++){
        await http.post(`/api/sheet_list/sumup_classifcation`, {sheet_id: targetSheetIds[i]}).then(response => {
          completedCount++;
          state.progress = Number.parseFloat(`${completedCount * 100 / targetSheetIds.length}`).toFixed(2);
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });

        // エラーありの場合は処理終了
        if(state.errors.length > 0){
          context.root.$store.dispatch("hideOverlay");
          state.isDispProgress = false;
          await search();
          return;
        }
      }

      await resolveAfterMilliSeconds();

      alert("処理が完了しました。");
      state.isDispProgress = false;
      await search();
      context.root.$store.dispatch("hideOverlay");
    }

    const resolveAfterMilliSeconds = () => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve('resolved');
        }, 1);
      });
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      state.condition = context.root.$store.state.sheetListCondition;
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      search,
      searchClick,
      convertCaptureDate,
      convertAggregatedAt,
      clearCondition,
      changePage,
      toSaitenList,
      reload,
      schoolChanged,
      goWebupList,
      sumupClassifcation,
    }
  }
});
